"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FunctionalCarousel = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uuid = require("uuid");

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _reactI18next = require("react-i18next");

var _coreThemes = require("@legacy-vfuk/core-themes");

var _coreInteractiveIcon = _interopRequireDefault(require("@legacy-vfuk/core-interactive-icon"));

var _coreIcon = _interopRequireDefault(require("@legacy-vfuk/core-icon"));

var _coreMatchMedia = _interopRequireDefault(require("@legacy-vfuk/core-match-media"));

var _coreLanguagePacks = require("@legacy-vfuk/core-language-packs");

var _coreBaseProps = require("@legacy-vfuk/core-base-props");

var _locales = _interopRequireWildcard(require("./locales"));

var _utils = require("./utils");

var _CarouselArrow = _interopRequireDefault(require("./components/CarouselArrow"));

var _CarouselDotPager = _interopRequireDefault(require("./components/CarouselDotPager"));

var _CarouselLoaderPager = _interopRequireDefault(require("./components/CarouselLoaderPager"));

require("slick-carousel/slick/slick.css");

var _FunctionalCarousel = _interopRequireDefault(require("./themes/FunctionalCarousel.theme"));

var Styled = _interopRequireWildcard(require("./styles/FunctionalCarousel.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FunctionalCarousel = /*#__PURE__*/function (_PureComponent) {
  _inherits(FunctionalCarousel, _PureComponent);

  var _super = _createSuper(FunctionalCarousel);

  // Separated all of the carousel functions into two util classes
  // SliderSettings contains all the functions to create a slider
  // SliderControls contains all the functions to control the slider
  function FunctionalCarousel(props) {
    var _this;

    _classCallCheck(this, FunctionalCarousel);

    _this = _super.call(this, props);
    _this.sliderRef = void 0;
    _this.sliderSettings = void 0;
    _this.sliderControls = void 0;
    _this.state = {
      currentSlide: 0,
      // Index of the current slide
      slidesToShow: 0,
      // Number of slides to show at a time
      slidesToScroll: 0,
      // Number of slides to move on click
      pagersToShow: 0,
      // Number of pagers to show
      transitioning: false,
      playing: false,
      // Determines whether the slides change is controller by pager.
      // For instance the LoaderPager switch slide every 3000ms.
      slidesControlledByPager: true
    };

    _this.setSliderRef = function (slider) {
      _this.sliderRef = slider;
    };

    _this.sliderSettings = new _utils.SliderSettings(_assertThisInitialized(_this));
    _this.sliderControls = new _utils.SliderControls(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FunctionalCarousel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.currentSlide !== prevProps.currentSlide) {
        this.sliderControls.goToPagerNumber(this.props.currentSlide);
      }
    }
  }, {
    key: "handleSlideControlChange",
    value: function handleSlideControlChange(controlled) {
      this.setState({
        slidesControlledByPager: controlled
      });
    }
  }, {
    key: "isSlideActive",
    value: function isSlideActive(index) {
      if (!Number.isInteger(this.state.currentSlide) || !this.state.slidesToScroll) return false;
      return this.state.currentSlide === this.state.slidesToScroll * index;
    }
  }, {
    key: "isSlideVisible",
    value: function isSlideVisible(index) {
      if (!Number.isInteger(this.state.currentSlide) || !this.state.slidesToScroll) return false;
      if (index < this.state.currentSlide) return false;
      return index < this.state.currentSlide + this.state.slidesToShow;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$pager,
          _this$props$pager2,
          _this$props$arrows,
          _this$props$arrows2,
          _this$props$pager3,
          _this$props$arrows3,
          _this$props$autoPlay,
          _this$props$pager4,
          _this2 = this,
          _this$props$pager5,
          _this$props$arrows4,
          _this$props$arrows5,
          _this$props$pager6,
          _this$props$arrows6,
          _this$props$pager7,
          _this$props$pager8,
          _this$props$pager9,
          _this$props$pager9$ti,
          _this$props$pager10,
          _this$props$pager11,
          _this$props$pager11$t,
          _this$props$pager12;

      (0, _coreLanguagePacks.loadResources)(this.props.i18n, _locales.componentName, _locales["default"]);
      return /*#__PURE__*/_react["default"].createElement(Styled.CarouselWrapper, _extends({
        allowOverflow: this.props.allowOverflow,
        "aria-label": this.props.srName,
        id: this.props.id,
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix),
        "data-component-name": _locales.componentName
      }, this.props.dataAttributes), /*#__PURE__*/_react["default"].createElement(Styled.Carousel, {
        pagerPosition: ((_this$props$pager = this.props.pager) === null || _this$props$pager === void 0 ? void 0 : _this$props$pager.position) || 'outside',
        transitioning: this.state.transitioning,
        allowOverflow: this.props.allowOverflow,
        elevatedCards: this.props.elevatedCards,
        functionalCarouselTheme: this.props.localTheme,
        theme: this.props.theme
      }, this.sliderSettings.showPreviousArrow && ((_this$props$pager2 = this.props.pager) === null || _this$props$pager2 === void 0 ? void 0 : _this$props$pager2.type) !== 'loader' ? /*#__PURE__*/_react["default"].createElement(_CarouselArrow["default"], {
        direction: "previous",
        inverse: (_this$props$arrows = this.props.arrows) === null || _this$props$arrows === void 0 ? void 0 : _this$props$arrows.inverse,
        position: (_this$props$arrows2 = this.props.arrows) === null || _this$props$arrows2 === void 0 ? void 0 : _this$props$arrows2.position,
        onClick: this.sliderControls.goToPreviousSlide,
        pagerPosition: (_this$props$pager3 = this.props.pager) === null || _this$props$pager3 === void 0 ? void 0 : _this$props$pager3.position,
        shape: (_this$props$arrows3 = this.props.arrows) === null || _this$props$arrows3 === void 0 ? void 0 : _this$props$arrows3.shape,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'prev-arrow')
      }) : null, (_this$props$autoPlay = this.props.autoPlay) !== null && _this$props$autoPlay !== void 0 && _this$props$autoPlay.active ? /*#__PURE__*/_react["default"].createElement(Styled.CarouselControls, {
        pagerPosition: ((_this$props$pager4 = this.props.pager) === null || _this$props$pager4 === void 0 ? void 0 : _this$props$pager4.position) || 'outside'
      }, this.state.playing ? /*#__PURE__*/_react["default"].createElement(_coreInteractiveIcon["default"], {
        srText: this.props.t('Pause'),
        name: "pause-circle",
        appearance: "primary",
        inverse: this.sliderSettings.invertedControls,
        onClick: this.sliderControls.pause,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'pause-icon')
      }) : /*#__PURE__*/_react["default"].createElement(_coreInteractiveIcon["default"], {
        srText: this.props.t('Play'),
        name: "play-circle",
        appearance: "primary",
        inverse: this.sliderSettings.invertedControls,
        onClick: this.sliderControls.play,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'play-icon')
      })) : null, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], _extends({}, this.sliderSettings.settings, {
        ref: this.setSliderRef
      }), _react["default"].Children.map(this.props.children, function (child, index) {
        if (_this2.isSlideVisible(index)) return child;
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          onClick: null,
          to: null,
          href: null
        });
      })), this.sliderSettings.showNextArrow && ((_this$props$pager5 = this.props.pager) === null || _this$props$pager5 === void 0 ? void 0 : _this$props$pager5.type) !== 'loader' ? /*#__PURE__*/_react["default"].createElement(_CarouselArrow["default"], {
        direction: "next",
        inverse: (_this$props$arrows4 = this.props.arrows) === null || _this$props$arrows4 === void 0 ? void 0 : _this$props$arrows4.inverse,
        position: (_this$props$arrows5 = this.props.arrows) === null || _this$props$arrows5 === void 0 ? void 0 : _this$props$arrows5.position,
        onClick: this.sliderControls.goToNextSlide,
        pagerPosition: (_this$props$pager6 = this.props.pager) === null || _this$props$pager6 === void 0 ? void 0 : _this$props$pager6.position,
        shape: (_this$props$arrows6 = this.props.arrows) === null || _this$props$arrows6 === void 0 ? void 0 : _this$props$arrows6.shape,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'next-arrow')
      }) : null, ((_this$props$pager7 = this.props.pager) === null || _this$props$pager7 === void 0 ? void 0 : _this$props$pager7.type) !== 'loader' ? /*#__PURE__*/_react["default"].createElement(Styled.CarouselDotPagerList, {
        position: ((_this$props$pager8 = this.props.pager) === null || _this$props$pager8 === void 0 ? void 0 : _this$props$pager8.position) || 'outside',
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'pager-list')
      }, new Array(this.state.pagersToShow).fill(0).map(function (_, i) {
        var _this2$props$pager, _this2$props$pager2;

        return /*#__PURE__*/_react["default"].createElement(_CarouselDotPager["default"], {
          appearance: (_this2$props$pager = _this2.props.pager) === null || _this2$props$pager === void 0 ? void 0 : _this2$props$pager.appearance,
          key: i,
          pagerCount: _this2.sliderSettings.slides.length,
          inverse: !!((_this2$props$pager2 = _this2.props.pager) !== null && _this2$props$pager2 !== void 0 && _this2$props$pager2.inverse),
          active: _this2.isSlideActive(i),
          index: i,
          onClick: _this2.sliderControls.goToPagerNumber,
          dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(_this2.props.dataSelectorPrefix, "dot-pager-".concat(i))
        });
      })) : null, (_this$props$pager9 = this.props.pager) !== null && _this$props$pager9 !== void 0 && (_this$props$pager9$ti = _this$props$pager9.titles) !== null && _this$props$pager9$ti !== void 0 && _this$props$pager9$ti.length && this.props.pager.type === 'loader' ? /*#__PURE__*/_react["default"].createElement(Styled.CarouselLoaderPager, {
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'loader-pager')
      }, /*#__PURE__*/_react["default"].createElement(Styled.CarouselLoaderPagerList, null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (_this$props$pager10 = this.props.pager) !== null && _this$props$pager10 !== void 0 && _this$props$pager10.showNavigation ? /*#__PURE__*/_react["default"].createElement(_coreMatchMedia["default"], {
        breakpoint: "lg",
        andAbove: true
      }, /*#__PURE__*/_react["default"].createElement(Styled.CarouselLoaderPagerArrow, {
        onClick: this.sliderControls.goToPreviousSlide
      }, /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
        name: "chevron-left",
        appearance: "secondary",
        size: 2,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'prev-icon')
      }), ' ', "Prev")) : null, (_this$props$pager11 = this.props.pager) === null || _this$props$pager11 === void 0 ? void 0 : (_this$props$pager11$t = _this$props$pager11.titles) === null || _this$props$pager11$t === void 0 ? void 0 : _this$props$pager11$t.map(function (title, i) {
        var _this2$props$pager3;

        return /*#__PURE__*/_react["default"].createElement(_CarouselLoaderPager["default"], {
          key: i,
          pagerCount: _this2.sliderSettings.slides.length,
          inverse: _this2.props.pager.inverse,
          active: _this2.isSlideActive(i),
          index: i,
          title: title,
          timeout: ((_this2$props$pager3 = _this2.props.pager) === null || _this2$props$pager3 === void 0 ? void 0 : _this2$props$pager3.timeout) || 3000,
          onChange: _this2.sliderControls.goToPagerNumber,
          autoplay: _this2.state.slidesControlledByPager,
          onSlideControlChange: function onSlideControlChange(controlled) {
            return _this2.handleSlideControlChange(controlled);
          },
          dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(_this2.props.dataSelectorPrefix, 'loader-pager')
        });
      }), (_this$props$pager12 = this.props.pager) !== null && _this$props$pager12 !== void 0 && _this$props$pager12.showNavigation ? /*#__PURE__*/_react["default"].createElement(_coreMatchMedia["default"], {
        breakpoint: "lg",
        andAbove: true
      }, /*#__PURE__*/_react["default"].createElement(Styled.CarouselLoaderPagerArrow, {
        onClick: this.sliderControls.goToNextSlide,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'loader-pager-arrow')
      }, this.props.t('Next'), /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
        name: "chevron-right",
        appearance: "secondary",
        size: 2,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'loader-next-icon')
      }))) : null))) : null));
    }
  }]);

  return FunctionalCarousel;
}(_react.PureComponent);

exports.FunctionalCarousel = FunctionalCarousel;
FunctionalCarousel.defaultProps = {
  allowOverflow: false,
  elevatedCards: false,
  id: (0, _uuid.v4)(),
  infiniteLoop: false,
  startingSlide: 0,
  currentSlide: 0,
  transitionSpeed: 1500,
  slidesToScroll: {}
};
FunctionalCarousel.displayName = "FunctionalCarousel";

var _default = (0, _reactI18next.withTranslation)()((0, _coreThemes.withLocalTheme)(FunctionalCarousel, _FunctionalCarousel["default"]));

exports["default"] = _default;
//# sourceMappingURL=FunctionalCarousel.js.map